import { AlgAttivazioniService } from "./../../../services/alg-attivazioni.service";
import {
  Attivazione,
  Status,
  NotorietaRadio
} from "./../../../models/attivazione";
import { Component, OnInit, ViewContainerRef } from "@angular/core";
import { FormGroup, FormControl, Validators } from "@angular/forms";
import { Observable } from "rxjs/Observable";
import { map, tap } from "rxjs/operators";
import { environment } from "../../../../environments/environment";
import { ModalDialogService } from "ngx-modal-dialog";
import { UtilsService } from "../../../services/utils.service";
import { AlgPrivacyService } from "../../../services/alg-privacy.service";

@Component({
  selector: "alg-attivazioni-step1",
  templateUrl: "./alg-attivazioni-step1.component.html",
  styleUrls: ["./alg-attivazioni-step1.component.scss"]
})
export class AlgAttivazioniStep1Component implements OnInit {
  public attivazione: Attivazione;
  public step1Form: FormGroup;
  public informativeNoteUrl$: Observable<string>;
  public isCfVisible = false;
  public privacyOptions = [
    {
      label: "Do il consenso",
      value: "agree"
    },
    {
      label: "Nego il consenso",
      value: "disagree"
    }
  ];
  public privacyItems: any;
  private privacyFieldsMap = {
    commercialiALG: "privacyComCom",
    profilazioneALG: "privacyProf",
    qualità: "privacyQualServ",
    commercialiTerzi: "privacyComTer",
    profilazioneTerzi: "privacyProfTer"
  };
  public prefixPreFill: string;
  public downloadPDFlink = "";
  public titleRadioOptions = [
    {
      label: "Proprietà",
      value: "titleRadio1"
    },
    {
      label: "Locazione / comodato",
      value: "titleRadio2"
    },
    {
      label: "Uso / Usufrutto / Abitazione",
      value: "titleRadio3"
    },
    {
      label: "Altro da specificare",
      value: "titleRadio4"
    }
  ];
  public titleRadioValue: string = "";
  public isVeneto: boolean = false;
  public isGas: boolean = false;
  public isModalOpen: boolean = false;
  public day: string = "";
  public month: string = "";
  public year: string = "";
  public day2: string = "";
  public month2: string = "";
  public year2: string = "";
  public venetoForm: FormGroup;
  public notorietaForm: FormGroup;
  public venetoOptions = [
    {
      label: "Possiedo",
      value: "true"
    },
    {
      label: "Non possiedo",
      value: "false"
    }
  ];
  public notorietaOptions = [
    {
      label:
        "Che l'impianto gas, oggetto della richiesta di attivazione della fornitura a seguito di subentro, è stato modificato",
      value: NotorietaRadio.modificato
    },
    {
      label:
        "Che l'impianto gas, oggetto della richiesta di attivazione della fornitura a seguito di subentro, non è stato modificato e che è disponibile la documentazione attestante la sicurezza dell'impianto (dichiarazione di conformità o di rispondenza, ai sensi della Legge 46/90 o del D.M. 37/08, oppure scheda di verifica dei requisiti di sicurezza, di cui all'all. II del D.M. 26/11/98)",
      value: NotorietaRadio.non_modificato
    },
    {
      label:
        "Che l'impianto gas, oggetto della richiesta di attivazione della fornitura ad uso esclusivamente tecnologico (artigianale-industriale), è stato costruito nel rispetto della normativa antincendio</br>(Non selezionabile per le forniture ad uso domestico)",
      value: NotorietaRadio.tecnologico
    }
  ];
  public venetoProvinces = ["BL", "PD", "RO", "TV", "VE", "VR", "VI"];

  constructor(
    private api: AlgAttivazioniService,
    private utils: UtilsService,
    private modalDialogService: ModalDialogService,
    private viewContainer: ViewContainerRef,
    private privacySerice: AlgPrivacyService
  ) {
    this.informativeNoteUrl$ = this.privacySerice.onbPrivacyUrl$.pipe(
      map(urls => urls.informativeNote)
    );
  }

  ngOnInit() {
    // this.api.currentAttivazione
    // .subscribe((attivazione) => {
    //   this.attivazione = attivazione;
    //   if(this.attivazione._id) this.downloadPDFlink = environment.attivazioneUrl+this.attivazione._id+'.pdf';
    // });

    this.api.attivazione$
      .pipe(
        tap(attivazione => {
          //
        })
      )
      .subscribe(attivazione => {
        this.attivazione = attivazione;
        // impostare il veneto e il gas qui
        if (this.venetoProvinces.indexOf(this.attivazione.province) > -1) {
          this.isVeneto = true;
          this.attivazione.venetoRadio = "false";
        } else {
          this.attivazione.venetoRadio = "";
        }
        if (attivazione.fornitureType != "Luce") this.isGas = true;
        // aggiunta pdf link
        if (this.attivazione.id)
          this.downloadPDFlink =
            environment.attivazioneUrl + this.attivazione.id + ".pdf";
        // aggiunta radio
        if (this.attivazione.titleRadio1) this.titleRadioValue = "titleRadio1";
        if (this.attivazione.titleRadio2) this.titleRadioValue = "titleRadio2";
        if (this.attivazione.titleRadio3) this.titleRadioValue = "titleRadio3";
        if (this.attivazione.titleRadio4) this.titleRadioValue = "titleRadio4";
      });

    this.step1Form = new FormGroup({
      titleRadioOptions: new FormControl(this.titleRadioValue, {
        validators: [Validators.required]
      })
    });

    // venetoForm
    this.venetoForm = new FormGroup({
      venetoCity: new FormControl(this.attivazione.venetoCity, {}),
      venetoRadio: new FormControl(this.attivazione.venetoRadio, {}),
      day: new FormControl(this.day, {}),
      month: new FormControl(this.month, {}),
      year: new FormControl(this.year, {}),
      day2: new FormControl(this.day, {}),
      month2: new FormControl(this.month, {}),
      year2: new FormControl(this.year, {})
    });

    // notorietaForm
    this.notorietaForm = new FormGroup({
      notorietaRadio: new FormControl(this.attivazione.notorietaRadio, {
        validators: [Validators.required]
      })
    });
  }

  checkDate() {
    if (this.year != "" && this.month != "" && this.day != "")
      this.attivazione.venetoDate = `${this.month}/${this.day}/${this.year}`;
    if (this.year2 != "" && this.month2 != "" && this.day2 != "")
      this.attivazione.venetoStart = `${this.day2}/${this.month2}/${this.year2}`;
  }

  public nextStep() {
    if (this.step1Form.status === "VALID") {
      this.attivazione.titleRadio1 = false;
      this.attivazione.titleRadio2 = false;
      this.attivazione.titleRadio3 = false;
      this.attivazione.titleRadio4 = false;
      this.attivazione[this.titleRadioValue] = true;

      if ((this.isVeneto || this.isGas) && !this.isModalOpen) {
        this.isModalOpen = true;
      } else {
        if (this.isGas && !(this.notorietaForm.status === "VALID")) {
          //
        } else {
          this.isModalOpen = false;
          this.api.nextStep(this.attivazione, Status.step1);
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/components/alg-attivazioni/alg-attivazioni-step1/alg-attivazioni-step1.component.ts